import { render, staticRenderFns } from "./Calificaciones.vue?vue&type=template&id=6463597c&scoped=true"
import script from "./Calificaciones.vue?vue&type=script&lang=js"
export * from "./Calificaciones.vue?vue&type=script&lang=js"
import style0 from "./Calificaciones.vue?vue&type=style&index=0&id=6463597c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6463597c",
  null
  
)

export default component.exports